<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_63_17968"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="21"
    >
      <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_63_17968)">
      <path
        d="M11.106 12.5132V6.82839M11.106 12.5132L15.0171 14.748C15.1251 14.8097 15.2475 14.842 15.3719 14.8415C15.4964 14.8411 15.6185 14.808 15.7261 14.7456C15.8338 14.6831 15.9231 14.5935 15.9852 14.4857C16.0474 14.3779 16.0801 14.2556 16.0801 14.1312V5.21037C16.0801 5.08593 16.0474 4.96368 15.9852 4.85586C15.9231 4.74804 15.8338 4.65842 15.7261 4.59597C15.6185 4.53352 15.4964 4.50042 15.3719 4.5C15.2475 4.49958 15.1251 4.53185 15.0171 4.59357L11.106 6.82839M11.106 12.5132H8.97417M11.106 6.82839H6.84238C6.08854 6.82839 5.36556 7.12786 4.83251 7.66091C4.29946 8.19396 4 8.91693 4 9.67078V9.67078C4 10.4246 4.29946 11.1476 4.83251 11.6806C5.36556 12.2137 6.08854 12.5132 6.84238 12.5132M6.84238 12.5132V15.7108C6.84238 15.9935 6.95468 16.2646 7.15458 16.4645C7.35447 16.6644 7.62558 16.7767 7.90828 16.7767C8.19097 16.7767 8.46208 16.6644 8.66198 16.4645C8.86187 16.2646 8.97417 15.9935 8.97417 15.7108V12.5132M6.84238 12.5132H8.97417"
        stroke="#666666"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="stroke"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
